module.exports = __webpack_public_path__ + "static/media/sport-boxing.f46b0e46.mp4";